import { render, staticRenderFns } from "./Municipios.vue?vue&type=template&id=66854e7f&scoped=true&"
import script from "./Municipios.vue?vue&type=script&lang=js&"
export * from "./Municipios.vue?vue&type=script&lang=js&"
import style0 from "./Municipios.vue?vue&type=style&index=0&id=66854e7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66854e7f",
  null
  
)

export default component.exports